import React from 'react';
import { Column } from '@ant-design/plots';

const DownloadsByFuntion = (props) => {
  const data = [
  ];
  props.functionData.forEach((value) => {

    var functionName = value.position;
    var length = 14;
    var trimmedFunctionName = functionName.substring(0, length) + '..';

    data.push(
      {
        'FunctionTrimmed': trimmedFunctionName,
        'Function': value.position,
        'Downloads': parseInt(value.downloads),
      }
    )
  })

  const config = {
    data,
    // point: {
    //   size: 20,
    //   shape: 'diamond',
    //   style: {
    //     fill: 'white',
    //     stroke: '#2593fc',
    //     lineWidth: 2,
    //   }
    // },
    xField: 'FunctionTrimmed',
    yField: 'Downloads',
    meta: false,
    isStack: true,
    axis: {
      x: {

        // This part is the configuration of the grid lines 
        // grid: true,  //Whether to show grid lines   
        // gridLineWidth: 2,  //gridline width   
        //This part is the configuration of the axis 
        line: true,  //Whether the axis is shown   
        lineLineWidth: 1,  //width of axis   
        lineStroke: '#666',  //axis Stroke   
        //This part is the configuration of the axis scale 
        tick: false,  //whether the scale is displayed   
        tickLineWidth: 2,  //width of scale line   
        tickLength: 2,  //gradeline length   
        tickStroke: '#666',  // tick-line colour   
        // This part is the configuration of the axis label 
        label: true,  //Whether the scale value is displayed   
        labelFontSize: 9,  // Scale value text size   
        // labelFill: '#009900',  //scale-valuefontcolor   
        labelFontWeight: 500,  // Scale value font thickness   
      },
      y: {

        // This part is the configuration of the grid lines 
        grid: true,  //Whether to show grid lines   
        gridLineWidth: 1,  //gridline width   
        //This part is the configuration of the axis 
        line: true,  //Whether the axis is shown   
        lineLineWidth: 0,  //width of axis   
        lineStroke: '#666',  //axis Stroke   
        //This part is the configuration of the axis scale 
        tick: false,  //whether the scale is displayed   
        tickLineWidth: 2,  //width of scale line   
        tickLength: 2,  //gradeline length   
        tickStroke: '#3366ff',  // tick-line colour   
        // This part is the configuration of the axis label 
        label: true,  //Whether the scale value is displayed   
        labelFontSize: 9,  // Scale value text size   
        // labelFill: '#009900',  //scale-valuefontcolor   
        labelFontWeight: 500,  // Scale value font thickness  
        gridLineDash: [0, 0]
      }
    },
    scrollbar: {
      type: 'horizontal',
      style: {
        trackColor: '#F0FAFF',
        thumbColor: '#D7F2FF'
      },
    },
    tooltip: {
      showTitle: false,
      items: ['Function', 'Downloads'],
    },
    scale: {
      x: { "type": "band", padding: 0.5 }
    },
    style: {
      maxWidth: 15,
      minWidth: 15,
      fill: '#667AFF',
      radiusTopLeft: 10,
      radiusTopRight: 10,
      radiusBottomLeft: 10,
      radiusBottomRight: 10,
    },
    height: 260,
  };

  // const config = {
  //   marginTop: 40,
  //   data: [
  //     { Id: 1, Label: 'x-axis tag 1', Value: 200 },
  //     { Id: 3, Label: 'x-axis tag 2', Value: 300 },
  //     { Id: 4, Label: 'x-axis tag 3', Value: 400 },
  //     { Id: 5, Label: 'x-axis tag 4', Value: 500 },
  //     { Id: 6, Label: 'x-axis tag 5', Value: 600 },
  //     { Id: 7, Label: 'x-axis tag 6', Value: 700 },
  //   ],
  //   xField: 'Label',
  //   //set data encoding 
  //   yField: 'Value',
  //   axis: {
  //     //configure x-axis 
  //     x: {
  //       position: 'bottom',  // Set the position of the coordinate axis   
  //       // This part is the configuration of the axis headers 
  //       title: 'x-axis header',  //axis title content   
  //       titleFontWeight: 500,  //Font thickness of the axis title   
  //       // This part is the configuration of the grid lines 
  //       grid: true,  //Whether to show grid lines   
  //       gridLineWidth: 2,  //gridline width   
  //       //This part is the configuration of the axis 
  //       line: true,  //Whether the axis is shown   
  //       lineLineWidth: 5,  //width of axis   
  //       lineStroke: '#f50',  //axis Stroke   
  //       //This part is the configuration of the axis scale 
  //       tick: true,  //whether the scale is displayed   
  //       tickLineWidth: 5,  //width of scale line   
  //       tickLength: 10,  //gradeline length   
  //       tickStroke: '#3366ff',  // tick-line colour   
  //       // This part is the configuration of the axis label 
  //       label: true,  //Whether the scale value is displayed   
  //       labelFontSize: 12,  // Scale value text size   
  //       labelFill: '#009900',  //scale-valuefontcolor   
  //       labelFontWeight: 500,  // Scale value font thickness   
  //     },
  //     //configure y-axis 
  //     y: {
  //       position: 'left',  // Set the position of the coordinate axis   
  //       // This part is the configuration of the axis headers 
  //       title: 'y-axis header',  //axis title content   
  //       titleFontWeight: 500,  //Font thickness of the axis title   
  //       // This part is the configuration of the grid lines 
  //       grid: true,  //Whether to show grid lines   
  //       gridLineWidth: 2,  //gridline width   
  //       //This part is the configuration of the axis 
  //       line: true,  //Whether the axis is shown   
  //       lineLineWidth: 5,  //width of axis   
  //       lineStroke: '#f50',  //axis Stroke   
  //       //This part is the configuration of the axis scale 
  //       tick: true,  //whether the scale is displayed   
  //       tickLineWidth: 5,  //width of scale line   
  //       tickLength: 10,  //gradeline length   
  //       tickStroke: '#3366ff',  // tick-line colour   
  //       // This part is the configuration of the axis label 
  //       label: true,  //Whether the scale value is displayed   
  //       labelFontSize: 12,  // Scale value text size   
  //       labelFill: '#009900',  //scale-valuefontcolor   
  //       labelFontWeight: 500,  // Scale value font thickness   
  //     },
  //   }
  // };

  if (data.length > 0) {
    return <Column {...config} />;
  }

};

export default DownloadsByFuntion;
